module.exports = __webpack_public_path__ + "static/media/moon.83a83c31.mp3";